<template>
  <div class="costInfo-page">
    <div class="costInfo-page-title">
      About credits usage
    </div>
    <div class="costInfo-page-content">
      Image face swapping will cost 1 credit. Video face swapping will cost 1 credit per second.
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      
    };
  },
  async mounted() {
    
  },
  methods: {
    async declineClick(){
      this.$emit("declineClick");
    },
    
    async allowClick() {
      this.$emit("allowClick");
    },
    returnNewLink(){
      const { href } = this.$router.resolve({
        path: '/disclaimer'
      });
      this.logEvent('fw_home_disclaimer',{fw_module_name:'disclaimer',fw_page:'home'})
      window.open(href, '_blank');
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.costInfo-page {
  font-family: 'Microsoft YaHei','PingFang SC';
  .costInfo-page-title{
    font-size: 25px;
    font-weight: 600;
    color: #000000;
    text-align: center;
  }
  .costInfo-page-content{
    font-size: 17px;
    font-weight: 600;
    color: #767676;
    margin: 20px 33px;
    line-height: 25px;
  }
}
</style>
